export enum WdtStatusEnum {
  Unconfirmed = 0,
  Confirmed = 1,
  All = 2,
}
